import { getScoreBg, getScoreColor } from '../../theme';

export const MARKET_QUALITY_LEVEL = {
  GOOD: 'veryGood',
  NEUTRAL: 'fair',
  WEAK: 'poor',
  UNKNOWN: 'unknown',
};

export const SETUP_META = {
  SPRING: { labelKey: 'marketInternalRadar.setup.spring', fallback: 'Spring', tone: 'success' },
  BREAKOUT: { labelKey: 'marketInternalRadar.setup.breakout', fallback: 'Breakout', tone: 'info' },
  UNVALIDATED: { labelKey: 'marketInternalRadar.setup.unvalidated', fallback: 'Unvalidated', tone: 'warning' },
};

export const VALIDATION_META = {
  validated: { labelKey: 'marketInternalRadar.validation.validated', fallback: 'Validated', tone: 'success' },
  fragile: { labelKey: 'marketInternalRadar.validation.fragile', fallback: 'Fragile', tone: 'warning' },
  screenOnly: { labelKey: 'marketInternalRadar.validation.screenOnly', fallback: 'Screen only', tone: 'warning' },
};

export const HEADLINE_META = {
  validatedAvailable: { labelKey: 'marketInternalRadar.board.validatedAvailable', fallback: 'Validated setups available', tone: 'success' },
  fragileOnly: { labelKey: 'marketInternalRadar.board.fragileOnly', fallback: 'Only fragile setups available', tone: 'warning' },
  screenOnly: { labelKey: 'marketInternalRadar.board.screenOnly', fallback: 'Screen-only candidates', tone: 'warning' },
  validatedOnly: { labelKey: 'marketInternalRadar.board.validatedOnly', fallback: 'Validated filter active', tone: 'info' },
};

export const toneColor = {
  success: '#10b981',
  info: '#2563eb',
  warning: '#d97706',
  danger: '#ef4444',
};

export const toneBg = {
  success: '#ecfdf5',
  info: '#eff6ff',
  warning: '#fffbeb',
  danger: '#fef2f2',
};

export const formatNumber = (value, digits = 2) => {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return Number(value).toFixed(digits);
};

export const formatPercent = (value, digits = 1) => {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return `${Number(value).toFixed(digits)}%`;
};

export const formatRatio = (value, digits = 2) => {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return Number(value).toFixed(digits);
};

export const marketQualityLevel = (label) => MARKET_QUALITY_LEVEL[label || 'UNKNOWN'] || 'unknown';

export const marketQualityColor = (label) => getScoreColor(marketQualityLevel(label));

export const marketQualityBg = (label) => getScoreBg(marketQualityLevel(label));

export const prettyDate = (value, locale = 'en-US') => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' });
};

export const normalizeHeadline = (summary) => {
  const headline = summary?.headline;
  const fallbackMeta = HEADLINE_META[headline?.key] || HEADLINE_META.screenOnly;
  if (headline?.label_key) {
    return {
      labelKey: headline.label_key,
      fallback: fallbackMeta.fallback,
      tone: headline.tone || fallbackMeta.tone,
    };
  }
  return fallbackMeta;
};

export const getSetupMeta = (setup) => SETUP_META[setup || 'UNVALIDATED'] || SETUP_META.UNVALIDATED;

export const getValidationMeta = (key) => VALIDATION_META[key || 'screenOnly'] || VALIDATION_META.screenOnly;

export const translateSemantic = (t, semantic, fallback) => {
  if (!semantic) return fallback || '—';
  if (semantic.label_key) return t(semantic.label_key, fallback || semantic.key || '—');
  return fallback || semantic.key || '—';
};
